import dateTimeFormatter from 'mrf/utils/DateTimeFormatter';
import ListCRUD from 'mrf/view/ListCRUD';
import React from 'react';
import {useTranslation} from "react-i18next";

export default function LicenseComunicationList({ match }) {

    const {t} = useTranslation();

    const fields = [
        { name: t('Transfer Code'), key: 'communicationProcessId' },
        { name: t('Importing Country'), keys: ['communicationProcess', 'importingCountry', 'institution', 'country', 'name'] },
        { name: t('Exporting Country'), keys: ['communicationProcess', 'exportingCountry', 'institution', 'country', 'name'] },
        { name: t('License Issue Date'), key: 'issueDate', map: dateTimeFormatter },
    ];

    return (
        <ListCRUD
            plural='communicationLicenses'
            singular='communicationLicense'
            fields={fields}
            match={match}
            disableViewButton
            disableNewButton
            disableEditButton
        />
    );
};